module.exports = __webpack_public_path__ + "img/phantom_assassin_alt1.53b04794.png";